export { default } from './Navigator';



// WEBPACK FOOTER //
// ./src/components/Navigator/index.js